import { render } from "./NsiMpkStatusCard.vue?vue&type=template&id=6fd8d327"
import script from "./NsiMpkStatusCard.vue?vue&type=script&lang=js"
export * from "./NsiMpkStatusCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__